import React from 'react';
import ProjectDetail from './ProjectDetail';
import { projectMeta } from './data';
import { toCdn } from '../utils/cdn';
import ProgressiveImg from '../components/ProgressiveImg';
import Figure from '../components/Figure';

export default function Facebook() {
  const meta = projectMeta.facebook;
  return (
    <ProjectDetail title={meta.title} date={meta.date} role={meta.role} url={meta.url}>
      {/* Custom per-project content goes here */}

      <p>The Like Button is one of the most iconic products in the world with over 10 billion views daily. By 2014, the Like Button and social plugins were widely used by developers, however, the code and design had fallen out of date. The plugins didn't work on mobile, caused performance issues, and were not up to date with the latest design and development standards.</p>

      <p>To bring these products up to date I redesigned the Like Button and entire suite of social plugins including Comments, Embedded Posts, Photos, and Videos. I worked closely with engineering, writing the initial front-end code and custom animations to ensure each plugin could adapt to different scenarios while maintaining performance.</p>

      <p>Many of the these developer tools were released during F8, Facebook's annual developer conference. As part of these releases I also created prototpyes and marketing materials that would be used at the conference and in press releases by Facebook's marketing teams.</p>

      <div className="media-gallery">
          <Figure caption="Facebook Like Button">
            <ProgressiveImg
              src={toCdn('/images/projects/facebook/facebook_1.webp')}
              alt="Facebook Like Button"
              className="gallery-item"
            />
          </Figure>
          <Figure caption="Facebook Social Plugins">
            <ProgressiveImg
              src={toCdn('/images/projects/facebook/facebook_2.webp')}
              alt="Facebook Social Plugins"
              className="gallery-item"
            />
          </Figure>
      </div>

      <h3>Facebook Developer Site</h3>
      <p>In 2015, I led the redesign of the Facebook Developer site, creating a scalable design system for marketing, documentation, and developer tools.</p>

      <p>We transitioned to an internal CMS, making it easier for the company to contribute content and enabling translation into seventeen languages.</p>

      <p>I worked closely with engineering and content teams, built the front-end for the marketing site, navigation, documentation, and developer tools.</p>

      <div className="media-gallery">
        <Figure caption="Facebook Developer Site">
          <ProgressiveImg
            src={toCdn('/images/projects/facebook/facebook_3.webp')}
            alt="Facebook Developer Site"
            className="gallery-item"
          />
        </Figure>
      </div>
    </ProjectDetail>
  );
}


